// src/routes/NotFound.tsx
import React from "react";
import { Helmet } from "react-helmet-async";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

// Define styled component for the container
const NotFoundContainer = styled.div`
  text-align: center;
  padding: 50px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #1a1a1a; /* Dark theme consistent with OLSME */
  color: #ffffff; /* White text for contrast */
`;

const Title = styled.h1`
  font-size: 48px;
  font-weight: 700;
  color: #ffcc00; /* Yellow accent consistent with OLSME */
  margin-bottom: 20px;
`;

const Description = styled.p`
  font-size: 18px;
  color: #cccccc; /* Light gray for readability */
  margin-bottom: 30px;
`;

// Define the component with TypeScript
const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <NotFoundContainer>
      <Helmet>
        <title>404 - Page Not Found | One Light System OLS</title>
        <meta name="description" content="The page you are looking for was not found on One Light System OLS." />
        <meta name="robots" content="noindex" /> {/* Prevent indexing of 404 pages */}
        <meta property="og:title" content="404 - Page Not Found | One Light System OLS" />
        <meta property="og:description" content="The page you are looking for doesn’t exist or has been moved." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="404 - Page Not Found | One Light System OLS" />
        <meta name="twitter:description" content="The page you are looking for doesn’t exist or has been moved." />
      </Helmet>
      <Title>Oops! 404 - Page Not Found</Title>
      <Description>The page you’re looking for doesn’t exist or has been moved.</Description>
      <Button
        type="primary"
        onClick={handleBackToHome}
        aria-label="Go back to home page"
        style={{
          backgroundColor: "#ffaa00", // Yellow button consistent with OLSME
          borderColor: "#ffaa00",
          color: "#0427f4", // Blue text for contrast
        }}
      >
        Back to Home
      </Button>
    </NotFoundContainer>
  );
};

export default NotFound;